import { connect } from 'react-redux';
import BookModule from '.';
import { AUTOSUGGEST_MINIMUM_INPUT_CHARS } from '../../../../../config';
import { isEmptyString } from '../../../../../core/util/string';
import { getSymptomsListUrl } from '../../../../../core/dapi/symptom';
import { apiGetRuntime } from '../../../../../core/dapi';

const SUGGESTIONS = 'symptom-suggestions';

const mapDispatchToProps = dispatch => ({
  fetchSuggestions: input => {
    if (!isEmptyString(input) && input.length >= AUTOSUGGEST_MINIMUM_INPUT_CHARS) {
      const url = getSymptomsListUrl(input, 100);
      apiGetRuntime(dispatch, SUGGESTIONS, url);
    }
  },
});

export default connect(
  null /* mapStateToProps */,
  mapDispatchToProps
)(BookModule);
